import React from 'react';

export default function PriceCard({ label, value, change, changeLabel }) {
  const isPositive = change >= 0;
  return (
    <div className="price-card">
      <div className="price-label">{label}</div>
      <div className="price-value">{value?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '—'}</div>
      {change !== undefined && change !== null && (
        <div className={`price-change ${isPositive ? 'positive' : 'negative'}`}>
          {isPositive ? '+' : ''}{change.toFixed(2)}{changeLabel || ''}
        </div>
      )}
    </div>
  );
}
